// src/layouts/AdminLayout.jsx - Unified responsive layout for admin
import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../services/firebase';
import UnifiedSidebar from '../components/unified/UnifiedSidebar';
import UnifiedNavbar from '../components/unified/UnifiedNavbar';

export default function AdminLayout({ user, onLogout }) {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  // Detect screen size for responsive behavior
  useEffect(() => {
    const checkScreenSize = () => {
      const isDesktopOrLarger = window.innerWidth >= 1024;
      setIsMobile(!isDesktopOrLarger); // isMobile = true for tablet and mobile (<1024px)

      // Only show sidebar on desktop and larger
      setSidebarOpen(isDesktopOrLarger);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      onLogout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar only for desktop and larger screens */}
      {sidebarOpen && (
        <UnifiedSidebar
          user={user}
          isOpen={sidebarOpen}
          setIsOpen={setSidebarOpen}
          isMobile={isMobile}
          role="admin"
        />
      )}

      {/* Mobile overlay when sidebar is open (now only applies to desktop where sidebar can actually open) */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content area */}
      <div className={`transition-all duration-300 ml-0`}>
        {/* Top navbar for all screen sizes */}
        <UnifiedNavbar
          user={user}
          onLogout={handleLogout}
          isMobile={isMobile}
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />

        {/* Page content with top padding to account for fixed navbar */}
        <main className="min-h-screen p-4 pt-20">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
